import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Input from '../input';
import Popup from './';

class ReportPopup extends Component {
  static propTypes = {
    route: PropTypes.string.isRequired,
  };

  state = {
    sendData: false,
    error: null,
    success: false,
    file: null,
    key: 0,
  };

  addFile = e => {
    this.setState({
      file: true,
    });
  };

  deleteFile = () => {
    this.setState({
      file: null,
      key: this.state.key + 1,
    });
  };

  confirm = e => {
    e.preventDefault();

    const { route } = this.props;

    let formData = new FormData(this.form);

    let headers = {
      method: 'POST',
      body: formData,
      headers: {},
    };

    // if (process.env.NODE_ENV != 'dev') {
    // 	headers.credentials = 'include';
    // }

    this.setState({
      sendData: true,
      error: null,
    });

    fetch(route, headers)
      .then(response => response.json())
      .then(json => {
        if (json.status == 'success') {
          this.setState({
            sendData: false,
            error: null,
            success: true,
          });
        } else {
          this.setState({
            sendData: false,
            error: json.errors.message,
          });
        }
      })
      .catch(error => {
        this.setState({
          sendData: false,
          error: null,
        });
      });
  };

  render() {
    const { sendData, error, success, file, key } = this.state;

    if (success)
      return (
        <Popup
          type="alert"
          status="success"
          title="Отлично!"
          message="Ваше сообщение отправлено. Спасибо, что помогаете сделать наш сайт лучше!"
          button="Назад"
        />
      );

    let btnClasses = ['btn'];

    if (sendData) btnClasses.push('btn--loading');

    return (
      <div className="popup" data-type="report">
        <div className="popup__aside">
          <div className="card-popup__pic" />
        </div>
        <form className="popup__content" ref={node => (this.form = node)}>
          <div className="popup__content-inner">
            <div className="popup__section-title">
              <h3 className="heading heading--1 popup__title">Нашли ошибку?</h3>
              <p className="popup__txt">
                Нам очень жаль, что вы столкнулись с проблемами на нашем сайте.
                Пожалуйста, расскажите, что произошло, и мы исправим ошибку в
                ближайшее время.
              </p>
            </div>
            <div className="inp-group">
              <div className="row">
                <div className="inp-group__case">
                  <Input
                    label="Как с вами связаться?"
                    placeholder="E-mail или номер телефона"
                    name="contacts"
                    indie
                  />
                </div>
                <div className="inp-group__case">
                  <Input
                    label="Что случилось?"
                    name="bug"
                    textarea
                    placeholder="Что вызвало у вас затруднения?"
                    indie
                  />
                </div>
              </div>
              {file ? (
                <div className="row">
                  <div className="inp-group__case">
                    <div className="file-item">
                      <p>
                        Файл
                        <button
                          type="button"
                          onClick={this.deleteFile}
                        ></button>
                      </p>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            <div className="popup__btn-wrap">
              {error ? <p>{error}</p> : null}
              <div className="wrap">
                <button className={btnClasses.join(' ')} onClick={this.confirm}>
                  Отправить
                </button>
                <label
                  className="btn btn--file btn--outline"
                  style={file ? { display: 'none' } : null}
                >
                  <input
                    ref={node => (this.file = node)}
                    key={key}
                    type="file"
                    accept="image/jpeg, image/png"
                    name="atachment"
                    onChange={this.addFile}
                  />
                </label>
              </div>
            </div>
          </div>
        </form>
        <button className="popup__close" type="button">
          <svg viewBox="0 0 18 18" width="18" height="18">
            <path d="M15.5 17.6l-6.5-6.5-6.5 6.5c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l6.5-6.5-6.5-6.5c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l6.5 6.5 6.5-6.5c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-6.5 6.5 6.5 6.5c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4s-.8-.2-1.1-.4z"></path>
          </svg>
        </button>
      </div>
    );
  }
}

export default ReportPopup;
